import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {CheckTransportAddedService} from './check-transport-added.service';
import {PersistDocumentService} from './persist-document.service';
import {ModalController} from '@ionic/angular';
import {GeneralService} from './general.service';

@Injectable({
    providedIn: 'root'
})
export class GeneralSaveDocumentService {

    constructor(private checkTransportAdded: CheckTransportAddedService,
                private persistDocumentService: PersistDocumentService,
                private modalController: ModalController,
                private generalServices: GeneralService) {
    }


    generalSaveDocument(document: DocumentModel) {
        if (!this.checkTransportAdded.isTransportAdded(document) && document.documentNumber === 0) {
            this.checkTransportAdded.addTransport(document);
        } else {
            this.persistDocumentService.persistDocument(document);
            this.modalController.dismiss(document);
            this.generalServices.createToast('Document Saved!');
        }
    }
}
